import React, { useMemo } from "react"
import { cva } from "class-variance-authority"
import cn from "../../../utils/classes"

export const enum typographyTypes {
  LABEL = "label",
  HELPER = "helper",
  TABLE = "table",
  HEADER_STATUS = "header_status",
  NORMAL = "normal",
  HREF = "href",
  ERROR = "error",
  PANEL_SUBTITLE = "panel_subtitle",
  PANEL_ITEM = "panel_item",
  PANEL_GROUP_TITLE = "panel_group_title",
  BANNER_TITLE = "banner_title",
}

export type TypographyKeys = keyof typeof typographyTypes
export type TypographyTypes = (typeof typographyTypes)[TypographyKeys]

export interface TypographyProps {
  text: React.ReactNode
  styleOverrides?: string
  variant: TypographyTypes
  ariaLabel?: string
}

export const Typography: React.FC<TypographyProps> = ({
  text,
  variant = typographyTypes.NORMAL,
  styleOverrides,
  ariaLabel,
}) => {
  const variants = cva([], {
    variants: {
      variant: {
        label: "label-text",
        helper: "helper-text",
        table: "table-text",
        header_status: "header-status-text",
        normal: "normal-text",
        href: "href-text",
        error: "error-text",
        panel_subtitle: "panel-subtitle-text",
        panel_item: "panel-item-text",
        panel_group_title: "panel-group-title-text",
        banner_title: "banner-title-text",
      },
    },
  })

  const className = useMemo(() => {
    return cn(
      variants({
        variant,
      }),
      styleOverrides,
    )
  }, [variants, variant, styleOverrides])

  return (
    <div className={className} aria-label={ariaLabel}>
      {text}
    </div>
  )
}

export default Typography
